import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
  collapsed: null,
  modelOpen: null,
  connectModel: null,
  propertiesModel: null,
  reportModel: null,
  nftIdToReport: ''
};

export const collapsedDashboard: any = createAsyncThunk(
  "collapsedDashboard",
  async (collapsed: any, thunkAPI) => {
    try {
      const result = collapsed;
      return result;
    } catch (error) {
      console.log("Error");
      return error;
    }
  }
);

export const mainModel: any = createAsyncThunk(
  "mainModel",
  async (modelOpen: any, thunkAPI) => {
    try {
      const result = modelOpen;
      return result;
    } catch (error) {
      console.log("Error");
      return error;
    }
  }
);

export const connectModelSlice: any = createAsyncThunk(
  "connectModel",
  async (connectModel: any, thunkAPI) => {
    try {
      const result = connectModel;
      return result;
    } catch (error) {
      console.log("Error");
      return error;
    }
  }
);


export const propertiesModelSlice: any = createAsyncThunk(
  "propertiesModel",
  async (propertiesModel: any, thunkAPI) => {
    try {
      const result = propertiesModel;
      return result;
    } catch (error) {
      console.log("Error");
      return error;
    }
  }
);


export const reportModelSlice: any = createAsyncThunk(
  "reportModel",
  async (reportModel: any, thunkAPI) => {
    try {
      const result = reportModel;
      return result;
    } catch (error) {
      console.log("Error");
      return error;
    }
  }
);


const modelSlice = createSlice({
  name: "Modals",
  initialState,
  reducers: {},
  extraReducers: {
    [collapsedDashboard.fulfilled.toString()]: (
      state,
      { payload }: PayloadAction
    ) => {
      state.collapsed = payload;
    },
    [mainModel.fulfilled.toString()]: (state, { payload }: PayloadAction) => {
      state.modelOpen = payload;
    },
    [connectModelSlice.fulfilled.toString()]: (
      state,
      { payload }: PayloadAction
    ) => {
      state.connectModel = payload;
    },
    [propertiesModelSlice.fulfilled.toString()]: (
      state,
      { payload }: PayloadAction
    ) => {
      state.propertiesModel = payload;
    },

    [reportModelSlice.fulfilled.toString()]: (
      state,
      { payload }: any
    ) => {
      state.reportModel = payload.state;
      state.nftIdToReport = payload.nftId
    },

 
  },
});

export const modelReducer = modelSlice.reducer;
